import { useState, useRef } from "react";
import { apiRequest } from "../api";

// ─── Divisions ────────────────────────────────────────────────────────────────
const DIVISIONS = [
  { name: "Health care",      tag: "healthcare"      },
  { name: "Neutraceuticals",  tag: "neutraceuticals" },
  { name: "Cosmetics",        tag: "cosmetics"       },
  { name: "Veterinary",       tag: "veterinary"      },
  { name: "Self Care",        tag: "selfcare"        },
  { name: "Surgical",         tag: "surgical"        },
];

// ─── Product Categories ───────────────────────────────────────────────────────
const CATEGORIES = [
  "Tablets",
  "Capsules",
  "Syrup",
  "Injections",
  "Ointment / Cream",
  "Liniment / Spray",
  "Skin & Hair",
  "Hair Care",
  "Petleen",
  "DAY CARE Antiseptic Disinfectant Liquid",
  "Ortho Rehab",
  "Equipments",
];

// ─── Chemical / Therapeutic Categories ───────────────────────────────────────
const CHEMICAL_CATEGORIES = [
  "Analgesics",
  "Anti Histaminics",
  "Anti Cold",
  "Anti Biotics",
  "Anti Ulcer",
  "Anti Diabetics",
  "Anti Hypertensive / Sedatives",
  "Neuron Rejuvenators",
  "Ointment / Cream",
];

// ─── Full product data from documents ─────────────────────────────────────────
// composition, description, packing_size, status from Web_product_content.docx + OTC docx
const PRODUCT_CONTENT = {
  // ── Health care › Tablets – Analgesics ────────────────────────────────────
  "BLEMOL-250": {
    composition: "Each uncoated tablet contains Paracetamol 250 mg",
    description: "Blemol-250 contains Paracetamol, a time-tested analgesic and antipyretic drug. Used to reduce fever and relieve mild to moderate pain such as headache, toothache, body pain, and cold or flu symptoms. Safe for both children and adults when taken in the recommended dose.",
    packing_size: "50×2×10 Blister pack",
    status: "Prescription drugs only",
  },
  "BLEMOL - 500": {
    composition: "Each uncoated tablet contains Paracetamol 500mg",
    description: "Blemol-500 contains Paracetamol, a time-tested analgesic and antipyretic drug. Used to reduce fever and relieve mild to moderate pain such as headache, toothache, body pain, and cold or flu symptoms.",
    status: "Prescription drugs only",
  },
  "BLEMOL - 650": {
    composition: "Each uncoated tablet contains Paracetamol 650mg",
    description: "Blemol-650 contains Paracetamol, used to reduce fever and relieve mild to moderate pain. Often used in adults for stronger pain and fever relief.",
    status: "Prescription drugs only",
  },
  "BLEGESIC - P": {
    composition: "Each film coated tablet contains Aceclofenac 100mg and Paracetamol 325mg",
    description: "Blegesic-P contains Aceclofenac (NSAID) and Paracetamol. Used to reduce pain and inflammation in conditions like rheumatoid arthritis, ankylosing spondylitis, and osteoarthritis. Also used to relieve back pain, toothache, and ear or throat pain.",
    status: "Prescription drugs only",
  },
  "GALGESIC": {
    composition: "Each film coated tablet contains Aceclofenac 100mg and Paracetamol 325mg",
    description: "Galgesic contains Aceclofenac (NSAID) and Paracetamol. Used to reduce pain and inflammation in conditions like rheumatoid arthritis, ankylosing spondylitis, and osteoarthritis. Also used for back pain, toothache, and ear or throat pain.",
    status: "Prescription drugs only",
  },
  "GALGESIC MR": {
    composition: "Each film coated tablet contains Aceclofenac 100mg, Paracetamol 325mg and Chlorzoxazone 250mg",
    description: "Galgesic-MR contains Aceclofenac, Chlorzoxazone (muscle relaxant) and Paracetamol. Used for low back pain, acute muscle spasms, muscular cramping, and traumatic injuries.",
    status: "Prescription drugs only",
  },
  "GALGESIC SP": {
    composition: "Each film coated tablet contains Aceclofenac 100mg, Paracetamol 325mg and Serratiopeptidase 15mg",
    description: "Galgesic-SP contains Aceclofenac, Serratiopeptidase (proteolytic enzyme) and Paracetamol. Used to relieve pain and inflammation in muscle pain, joint pain, and postoperative pain.",
    status: "Prescription drugs only",
  },
  "BLEENAC": {
    composition: "Each film coated tablet contains Diclofenac sodium 50mg and Paracetamol 325mg",
    description: "Bleenac contains Diclofenac (NSAID) and Paracetamol. Used to reduce pain and inflammation in arthritis, muscle pain, joint pain, back pain, and postoperative pain.",
    status: "Prescription drugs only",
  },
  "BLEESPAS": {
    composition: "Each uncoated tablet contains Paracetamol 500mg and Dicyclomine HCl 20mg",
    description: "Bleespas contains Paracetamol (analgesic) and Dicyclomine (antispasmodic). Indicated for stomach cramps, renal and biliary colic, functional bowel disease, and Irritable Bowel Syndrome (IBS).",
    status: "Prescription drugs only",
  },
  "NIMLEEN (Blue,Brown,Yellow)": {
    composition: "Each uncoated tablet contains Nimesulide 100mg",
    description: "Nimleen contains Nimesulide (NSAID). Used to reduce pain and inflammation in arthritis, muscle pain, joint pain, fever, dental pain, and postoperative pain.",
    status: "Prescription drugs only",
  },
  // ── Health care › Tablets – Anti Histaminics ──────────────────────────────
  "BLEECET": {
    composition: "Each film coated tablet contains Cetirizine Hydrochloride 10mg",
    description: "Bleecet contains Cetirizine (antihistamine). Used to relieve symptoms of allergic rhinitis, urticaria (skin hives), watery eyes, and itching caused by allergies.",
    status: "Prescription drugs only",
  },
  "CETLEEN": {
    composition: "Each film coated tablet contains Cetirizine Hydrochloride 10mg",
    description: "Cetleen contains Cetirizine (antihistamine). Used to treat allergic rhinitis, urticaria, and allergic skin reactions.",
    status: "Prescription drugs only",
  },
  "MONTLEEN-LC": {
    composition: "Each film coated tablet contains LevoCetirizine DiHydrochloride 5mg and Montelukast sodium 10mg",
    description: "Montleen-LC contains Levocetirizine (antihistamine) and Montelukast (leukotriene receptor antagonist). Used to treat allergic rhinitis, seasonal allergies, and chronic urticaria.",
    status: "Prescription drugs only",
  },
  // ── Health care › Tablets – Anti Cold ────────────────────────────────────
  "GALCOLD": {
    composition: "Each uncoated tablet contains Paracetamol 650mg, Phenylephrine HCl 10mg, Caffeine 30mg and Chlorpheniramine maleate 2mg",
    description: "Galcold contains Paracetamol, Phenylephrine (decongestant), Caffeine and Chlorpheniramine (antihistamine). Used to relieve cold and flu symptoms such as fever, headache, nasal congestion, sneezing, and runny nose.",
    status: "Prescription drugs only",
  },
  "BLEECOLD": {
    composition: "Each uncoated tablet contains Paracetamol 500mg, Phenylephrine HCl 5mg, Caffeine 30mg and Diphenhydramine HCl 25mg",
    description: "Bleecold contains Paracetamol, Phenylephrine (decongestant), Caffeine and Diphenhydramine (antihistamine). Used to relieve cold and flu symptoms.",
    status: "Prescription drugs only",
  },
  "BLEECOLD PLUS": {
    composition: "Each uncoated tablet contains Paracetamol 650mg, Phenylephrine HCl 5mg and Chlorpheniramine maleate 2mg",
    description: "Bleecold Plus contains Paracetamol, Phenylephrine (decongestant) and Chlorpheniramine (antihistamine). Used for fever, headache, body pain, nasal congestion, sneezing, and runny nose.",
    status: "Prescription drugs only",
  },
  // ── Health care › Tablets – Anti Biotics ─────────────────────────────────
  "CIPROLEEN-250": {
    composition: "Each film coated tablet contains Ciprofloxacin Hydrochloride 250mg",
    description: "Ciproleen-250 contains Ciprofloxacin (fluoroquinolone antibiotic). Used to treat UTIs, respiratory tract infections, gastrointestinal infections, skin infections, and typhoid fever.",
    status: "Prescription drugs only",
  },
  "CIPROLEEN-500": {
    composition: "Each film coated tablet contains Ciprofloxacin Hydrochloride 500mg",
    description: "Ciproleen-500 contains Ciprofloxacin (fluoroquinolone antibiotic). Used to treat bacterial infections including UTIs, respiratory, gastrointestinal, and skin infections.",
    status: "Prescription drugs only",
  },
  "BLEEMOX CV 625": {
    composition: "Each film coated tablet contains Amoxicillin 500mg and Clavulanic acid 125mg",
    description: "Bleemox CV 625 contains Amoxicillin and Clavulanic acid (beta-lactamase inhibitor). A broad-spectrum antibiotic for respiratory tract, urinary tract, skin, and soft tissue infections.",
    status: "Prescription drugs only",
  },
  "BLECEF-O 200": {
    composition: "Each film coated tablet contains Cefixime 200mg and Ofloxacin 200mg",
    description: "Blecef-O contains Cefixime (3rd generation cephalosporin) and Ofloxacin (fluoroquinolone). Used for typhoid, community-acquired pneumonia, UTI, fever of unknown origin, and post-surgical infections.",
    status: "Prescription drugs only",
  },
  "BLECEF-200": {
    composition: "Each film coated tablet contains Cefixime 200mg",
    description: "Blecef-200 contains Cefixime, a third-generation cephalosporin antibiotic. Used for respiratory tract infections, UTIs, abdominal infections, and typhoid.",
    status: "Prescription drugs only",
  },
  // ── Health care › Tablets – Anti Diabetics ───────────────────────────────
  "B-MET-500": {
    composition: "Each uncoated tablet contains Metformin Hydrochloride 500mg",
    description: "B-Met-500 contains Metformin (biguanide antidiabetic). Used to manage type 2 diabetes mellitus by improving insulin sensitivity and reducing hepatic glucose production.",
    status: "Prescription drugs only",
  },
  "B-MET-G1": {
    composition: "Each uncoated tablet contains Metformin HCl 500mg and Glimepiride 1mg",
    description: "B-Met-G1 contains Metformin and Glimepiride (sulfonylurea). Combination antidiabetic therapy for type 2 diabetes.",
    status: "Prescription drugs only",
  },
  "B-MET-G2": {
    composition: "Each uncoated tablet contains Metformin HCl 500mg and Glimepiride 2mg",
    description: "B-Met-G2 contains Metformin and Glimepiride 2mg. Combination antidiabetic therapy for type 2 diabetes blood glucose control.",
    status: "Prescription drugs only",
  },
  "B-MET-TRIO 2mg": {
    composition: "Each uncoated tablet contains Metformin HCl 500mg, Glimepiride 2mg and Voglibose 0.2mg",
    description: "B-Met Trio 2mg contains Metformin, Glimepiride and Voglibose (alpha-glucosidase inhibitor). Triple combination for comprehensive type 2 diabetes management.",
    status: "Prescription drugs only",
  },
  // ── Health care › Tablets – Anti Hypertensive / Sedatives ────────────────
  "BLEPRAX - 0.25": {
    composition: "Each tablet contains Alprazolam 0.25mg",
    description: "Bleprax 0.25 contains Alprazolam (benzodiazepine). Used for anxiety disorders, panic disorders, and anxiety associated with depression.",
    status: "Prescription drugs only",
  },
  "BLEPRAX - 0.5": {
    composition: "Each tablet contains Alprazolam 0.5mg",
    description: "Bleprax 0.5 contains Alprazolam (benzodiazepine). Used for anxiety disorders and panic disorders.",
    status: "Prescription drugs only",
  },
  "TELMILEEN-40": {
    composition: "Each film coated tablet contains Telmisartan 40mg",
    description: "Telmileen-40 contains Telmisartan (ARB antihypertensive). Used to treat hypertension and reduce risk of cardiovascular events.",
    status: "Prescription drugs only",
  },
  "TELMILEEN-H": {
    composition: "Each film coated tablet contains Telmisartan 40mg and Hydrochlorothiazide 12.5mg",
    description: "Telmileen-H contains Telmisartan and Hydrochlorothiazide (diuretic). Combination therapy for hypertension management.",
    status: "Prescription drugs only",
  },
  "ATOLEEN-10": {
    composition: "Each film coated tablet contains Atorvastatin 10mg",
    description: "Atoleen-10 contains Atorvastatin (statin). Used to reduce LDL cholesterol and prevent cardiovascular disease.",
    status: "Prescription drugs only",
  },
  // ── Health care › Tablets – Anti Ulcer ───────────────────────────────────
  "PANTOLIK-40": {
    composition: "Each enteric coated tablet contains Pantoprazole sodium 40mg",
    description: "Pantolik-40 contains Pantoprazole (proton pump inhibitor). Used for GERD, gastric and duodenal ulcers, and acid-related disorders.",
    status: "Prescription drugs only",
  },
  "PANTOLIK - D": {
    composition: "Each tablet contains Pantoprazole 40mg and Domperidone 10mg",
    description: "Pantolik-D contains Pantoprazole (PPI) and Domperidone (prokinetic). Used for GERD with motility issues, acidity, and gastric discomfort.",
    status: "Prescription drugs only",
  },
  "RANLEE-150": {
    composition: "Each film coated tablet contains Ranitidine HCl 150mg",
    description: "Ranlee-150 contains Ranitidine (H2 receptor antagonist). Used for gastric ulcers, duodenal ulcers, GERD, and acid-related conditions.",
    status: "Prescription drugs only",
  },
  // ── Health care › Tablets – Misc ─────────────────────────────────────────
  "BLECAL-D3": {
    composition: "Each tablet contains Calcium carbonate 500mg (elemental calcium 200mg) and Vitamin D3 250 IU",
    description: "Blecal-D3 contains Calcium carbonate and Vitamin D3. Used for calcium deficiency, osteoporosis prevention, and overall bone health.",
    status: "Prescription drugs only",
  },
  // ── Health care › Tablets – Neuron Rejuvenators ───────────────────────────
  "NEUROLEEN FORTE": {
    composition: "Each tablet contains Methylcobalamin 1500mcg, Alpha Lipoic Acid 100mg, Pyridoxine HCl 3mg and Folic Acid 1.5mg",
    description: "Neuroleen Forte contains Methylcobalamin (active B12), Alpha Lipoic Acid, Pyridoxine and Folic Acid. Used for peripheral neuropathy, nerve pain, tingling, and nerve health support.",
    status: "Prescription drugs only",
  },
  // ── Health care › Capsules ────────────────────────────────────────────────
  "BLEMOX 250": {
    composition: "Each capsule contains Amoxicillin 250mg",
    description: "Blemox 250 contains Amoxicillin (penicillin antibiotic). Used for bacterial infections of the ear, nose, throat, respiratory tract, and urinary tract.",
    status: "Prescription drugs only",
  },
  "BLEMOX-500": {
    composition: "Each capsule contains Amoxicillin 500mg",
    description: "Blemox-500 contains Amoxicillin (penicillin antibiotic). Used for bacterial infections of the respiratory tract, ear, nose, throat, urinary tract, and skin.",
    status: "Prescription drugs only",
  },
  "BLECLOX - LB": {
    composition: "Each capsule contains Amoxicillin 500mg, Cloxacillin 250mg and Lactobacillus (probiotic)",
    description: "Bleclox-LB contains Amoxicillin and Cloxacillin (combined penicillins) with Lactobacillus. Used for mixed bacterial infections and helps maintain gut flora during antibiotic therapy.",
    status: "Prescription drugs only",
  },
  "MECOBALEEN PLUS": {
    composition: "Each soft gelatin capsule contains Methylcobalamin 1500mcg, Alpha Lipoic Acid 100mg, Pyridoxine HCl 3mg and Folic Acid 1.5mg",
    description: "Mecobaleen Plus contains Methylcobalamin (active B12), Alpha Lipoic Acid, Pyridoxine and Folic Acid. Used for neuropathy, nerve pain, numbness, and tingling.",
    status: "Prescription drugs only",
  },
  "OMELEE-20": {
    composition: "Each capsule contains Omeprazole 20mg",
    description: "Omelee-20 contains Omeprazole (proton pump inhibitor). Used for GERD, gastric and duodenal ulcers, H. pylori eradication, and Zollinger-Ellison syndrome.",
    status: "Prescription drugs only",
  },
  "PANTOLIK - DSR": {
    composition: "Each hard gelatin capsule contains Pantoprazole 40mg and Domperidone 30mg (sustained release)",
    description: "Pantolik-DSR contains Pantoprazole (PPI) and Domperidone (prokinetic) in sustained release form. Used for GERD, acidity, gastric discomfort, and nausea.",
    status: "Prescription drugs only",
  },
  "RABLEEN-DSR": {
    composition: "Each hard gelatin capsule contains Rabeprazole sodium 20mg and Domperidone 30mg (sustained release)",
    description: "Rableen-DSR contains Rabeprazole (PPI) and Domperidone (prokinetic, SR). Used for GERD, peptic ulcers, and gastroparesis-related symptoms.",
    status: "Prescription drugs only",
  },
  "BRELEEN": {
    composition: "Each soft gelatin capsule contains Camphor 25mg, Chlorothymol 5mg, Eucalyptus 125mg, Menthol 55mg, Terpineol 120mg",
    description: "Breleen contains antiseptic and decongestant essential oils. Used for relief of cold symptoms, nasal congestion, and minor respiratory discomfort.",
    status: "Prescription drugs only",
  },
  "ELEEN 400": {
    composition: "Each soft gelatin capsule contains Vitamin E Acetate 400mg",
    description: "Eleen-400 contains Vitamin E (fat-soluble antioxidant). Used to support skin health, immunity, and to protect body cells from free radical damage.",
    status: "Prescription drugs only",
  },
  "K.COFF-SG": {
    composition: "Each soft gelatin capsule contains Chlorpheniramine, Dextromethorphan and Phenylephrine",
    description: "K-Coff-SG contains Chlorpheniramine (antihistamine), Dextromethorphan (cough suppressant) and Phenylephrine (decongestant). Used for cold and flu symptoms, dry cough, and nasal congestion.",
    status: "Prescription drugs only",
  },
  "Neu 1 Forte": {
    composition: "Each capsule contains Methylcobalamin 1500mcg, Niacinamide 100mg, Pyridoxine HCl 100mg and Benzyl Alcohol 2% w/w",
    description: "Neu 1 Forte is a B-complex vitamin combination containing Methylcobalamin, Niacinamide and Pyridoxine. Used for peripheral neuropathy, nerve pain, and B-vitamin deficiency.",
    status: "Prescription drugs only",
  },
  "FATAXY 3 - Capsules": {
    composition: "Each soft gelatin capsule contains Calcitriol 0.25mcg, Calcium carbonate 500mg, Omega-3 fatty acid 150mg, Methylcobalamin 1500mcg, Folic acid 400mcg, Disodium Tetraborate 1.5mg",
    description: "Fataxy-3 contains Calcitriol (active Vitamin D), Calcium, Omega-3 fatty acids, Methylcobalamin, and Folic Acid. Used for bone health, nerve function, and overall nutritional balance in osteoporosis and neuropathy.",
    status: "Prescription drugs only",
  },
  // ── Health care › Syrup ───────────────────────────────────────────────────
  "ALKALEEN Liquid": {
    composition: "Each 5ml contains Disodium hydrogen citrate 1.25g",
    description: "Alkaleen syrup contains Disodium hydrogen citrate (urinary alkalinizing agent). Used for urinary tract infections, burning urination (dysuria), and uric acid kidney stone prevention.",
    status: "Prescription drugs only",
  },
  "ALAXY (Expectorant)": {
    composition: "Each 5ml contains Ambroxol hydrochloride 15mg, Terbutaline sulphate 1.25mg, Guaiphenesin 50mg",
    description: "Alaxy syrup contains Ambroxol (mucolytic), Terbutaline (bronchodilator) and Guaiphenesin (expectorant). Used for productive cough, bronchitis, and respiratory conditions with excess mucus.",
    status: "Prescription drugs only",
  },
  "ALAXY - DX (Expectorant)": {
    composition: "Each 5ml contains Dextromethorphan 10mg, Chlorpheniramine maleate 2mg, Menthol 1.5mg",
    description: "Alaxy-DX syrup contains Dextromethorphan (cough suppressant), Chlorpheniramine (antihistamine) and Menthol. Used for dry cough associated with cold, flu, and upper respiratory tract allergies.",
    status: "Prescription drugs only",
  },
  "BLEECID MPS (Mint, Elachi)": {
    composition: "Each 5ml contains Dried Aluminium Hydroxide 250mg, Magnesium Hydroxide 250mg, Activated Dimethicone 50mg",
    description: "Bleecid MPS suspension contains Aluminium hydroxide and Magnesium hydroxide (antacids) with Dimethicone (anti-foaming). Used for acidity, acid reflux, gastritis, and gas-related stomach discomfort.",
    status: "Prescription drugs only",
  },
  "BLEEDRYL (Expectorant)": {
    composition: "Each 5ml contains Diphenhydramine HCl 12.5mg, Ammonium Chloride 100mg, Sodium Citrate 50mg, Menthol 1.5mg",
    description: "Bleedryl syrup contains Diphenhydramine (antihistamine), Ammonium Chloride (expectorant), Sodium Citrate, and Menthol. Used for dry or productive cough in cold, bronchitis, and upper respiratory infections.",
    status: "Prescription drugs only",
  },
  "BLECAL-D3 Syrup": {
    composition: "Each 5ml contains Calcium carbonate 625mg (elemental calcium 250mg), Magnesium Hydroxide 180mg (elemental Magnesium 75mg), Zinc Gluconate 14mg (elemental zinc 2mg), Vitamin D3 200 IU",
    description: "Blecal-D3 suspension contains Calcium, Magnesium, Zinc and Vitamin D3. Used as a dietary supplement for calcium and mineral deficiencies, osteoporosis, muscle cramps, and vitamin D deficiency.",
    status: "Prescription drugs only",
  },
  "BLEMOL - 125": {
    composition: "Each 5ml contains Paracetamol 125mg",
    description: "Blemol-125 suspension contains Paracetamol. Commonly used in children for fever, cold, headache, toothache, and mild body pain.",
    status: "Prescription drugs only",
  },
  "BLEMOL - 250 Syrup": {
    composition: "Each 5ml contains Paracetamol 250mg",
    description: "Blemol-250 suspension contains Paracetamol. Used in children for fever, headache, toothache, cold, flu, and body aches.",
    status: "Prescription drugs only",
  },
  "BLEMOL-500 Syrup": {
    composition: "Each 5ml contains Paracetamol 500mg",
    description: "Blemol-500 suspension contains Paracetamol. Used for headache, fever, toothache, cold and flu symptoms, body pain, and muscle aches.",
    status: "Prescription drugs only",
  },
  "BLEMOL - M": {
    composition: "Each 5ml contains Paracetamol 250mg and Mefenamic acid 100mg",
    description: "Blemol-M contains Paracetamol and Mefenamic Acid. Combination analgesic and antipyretic used in children for fever, headache, toothache, ear pain, throat pain, and pain associated with infections.",
    status: "Prescription drugs only",
  },
  "BLECOLD Syrup": {
    composition: "Each 5ml contains Phenylephrine HCl 2.5mg, Chlorpheniramine maleate 2mg, Menthol 1.5mg",
    description: "Bleecold syrup contains Phenylephrine (decongestant), Chlorpheniramine (antihistamine) and Menthol. Used for common cold, allergic rhinitis, sinusitis, and upper respiratory tract infections.",
    status: "Prescription drugs only",
  },
  "BLEECOLD DROPS": {
    composition: "Each 5ml contains Phenylephrine HCl 2.5mg, Chlorpheniramine maleate 2mg",
    description: "Bleecold drops contains Phenylephrine (decongestant) and Chlorpheniramine (antihistamine). Used for common cold, allergic rhinitis, sinus congestion, and upper respiratory tract infections.",
    status: "Prescription drugs only",
  },
  "BLEEZYME - Syrup": {
    composition: "Each 5ml contains Pepsin 15mg, Vitamin B1 3mg, Vitamin B6 1mg, Vitamin B12 5mcg",
    description: "Bleezyme syrup contains Pepsin (digestive enzyme) with B-vitamins. Used as a digestive and nutritional supplement for poor appetite, indigestion, weakness, and fatigue.",
    status: "Prescription drugs only",
  },
  "BLEPLEX": {
    composition: "Each 5ml contains Thiamine HCl 3mg, Riboflavin 2.5mg, Pyridoxine HCl 1mg, Nicotinamide 25mg, D-Panthenol 2.5mg, Cyanocobalamin 5mcg, L-lysine monohydrochloride 25mg",
    description: "Bleplex syrup contains B-complex vitamins (B1, B2, B3, B5, B6, B12) and L-lysine. Used for vitamin B-complex deficiencies, improved energy, nerve health, and recovery during illness or stress.",
    status: "Prescription drugs only",
  },
  "CETLEEN Syrup": {
    composition: "Each 5ml contains Cetirizine Hydrochloride 5mg",
    description: "Cetleen syrup contains Cetirizine (antihistamine). Used to treat allergic rhinitis, urticaria, and other allergic skin reactions.",
    status: "Prescription drugs only",
  },
  "FERRILEEN": {
    composition: "Each 5ml contains Cyanocobalamin 5mcg, Folic acid 0.5mg, Ferric Ammonium citrate 100mg",
    description: "Ferrileen syrup contains Vitamin B12, Folic acid and Iron. Used for iron deficiency anaemia, megaloblastic anaemia, weakness, fatigue, and nutritional deficiencies.",
    status: "Prescription drugs only",
  },
  "K-COFF D": {
    composition: "Each 5ml contains Phenylephrine HCl 5mg, Dextromethorphan HBr 10mg, Chlorpheniramine maleate 2mg",
    description: "K-Coff-D syrup contains Phenylephrine (decongestant), Dextromethorphan (cough suppressant) and Chlorpheniramine (antihistamine). Used for cold, flu, allergic rhinitis, and upper respiratory tract infections.",
    status: "Prescription drugs only",
  },
  "K-COFF-LS": {
    composition: "Each 5ml contains Ambroxol Hydrochloride 30mg, Levosalbutamol Sulphate 1mg, Guaiphenesin 50mg",
    description: "K-Coff-LS syrup contains Ambroxol (mucolytic), Levosalbutamol (bronchodilator) and Guaiphenesin (expectorant). Used for productive cough in bronchitis, asthma, and COPD.",
    status: "Prescription drugs only",
  },
  "MONTLEEN-LC Syrup": {
    composition: "Each 5ml contains Levocetirizine DiHydrochloride 2.5mg, Montelukast sodium 4mg",
    description: "Montleen-LC syrup contains Levocetirizine (antihistamine) and Montelukast (leukotriene receptor antagonist). Used for allergic rhinitis, chronic urticaria, and bronchial asthma.",
    status: "Prescription drugs only",
  },
  "SUCRALEEN": {
    composition: "Each 5ml contains Sucralfate 500mg",
    description: "Sucraleen suspension contains Sucralfate (gastroprotective). Forms a protective coating over the stomach lining to heal gastric ulcers, duodenal ulcers, and gastritis.",
    status: "Prescription drugs only",
  },
  "SUCRALEEN-O": {
    composition: "Each 5ml contains Sucralfate 1000mg and Oxetacaine 10mg",
    description: "Sucraleen-O suspension contains Sucralfate (gastroprotective) and Oxetacaine (local anesthetic). Used for gastritis, gastric ulcers, acid reflux, and GERD with rapid pain relief.",
    status: "Prescription drugs only",
  },
  "Blemol Drops": {
    composition: "Each 5ml contains Paracetamol 100mg",
    description: "Blemol drops contains Paracetamol. Used in infants and young children for fever, cold, flu, teething pain, headache, and mild body aches.",
    status: "Prescription drugs only",
  },
  // ── Health care › Injections ──────────────────────────────────────────────
  "B-NEURON": {
    composition: "Each 2ml contains Methylcobalamin 1500mcg, Benzyl alcohol 2% w/w",
    description: "B-Neuron Injection contains Methylcobalamin (active B12). Used for Vitamin B12 deficiency, peripheral neuropathy, nerve pain, weakness, and fatigue.",
    status: "Prescription drugs only",
  },
  "B-NEURON FORTE": {
    composition: "Each 2ml contains Methylcobalamin 1500mcg, Pyridoxine HCl 100mg, Nicotinamide 100mg, Benzyl alcohol 2% w/w",
    description: "B-Neuron Forte Injection contains Methylcobalamin (B12), Pyridoxine (B6) and Nicotinamide (B3). Used for B-complex deficiencies, peripheral neuropathy, nerve pain, tingling, and fatigue.",
    status: "Prescription drugs only",
  },
  "PANTOLIK - 40 inj": {
    composition: "Each 2ml contains Pantoprazole sodium 40mg",
    description: "Pantolik-40 Injection contains Pantoprazole (proton pump inhibitor). Used for severe GERD, gastric and duodenal ulcers, Zollinger-Ellison syndrome, and stress-related acid secretion when oral medication cannot be taken.",
    status: "Prescription drugs only",
  },
  // ── Health care › Ointment / Cream ────────────────────────────────────────
  "BLEBACT": {
    composition: "Each gm contains Mupirocin 2% w/w",
    description: "Blebact contains Mupirocin (topical antibiotic). Used for impetigo, infected wounds, minor cuts, and skin infections caused by Staphylococcus and Streptococcus bacteria.",
    status: "Prescription drugs only",
  },
  "IONIC-4": {
    composition: "Each gm contains Itraconazole 1% w/w, Ofloxacin 0.75%, Ornidazole 2% w/w, Clobetasol Propionate 0.05% w/w, Methyl Paraben 0.16% w/w, Propyl paraben 0.033% w/w",
    description: "Ionic-4 cream contains Itraconazole (antifungal), Ofloxacin (antibiotic), Ornidazole (antiprotozoal) and Clobetasol (corticosteroid). Used for mixed infections involving fungi, bacteria, and protozoa with inflammation.",
    status: "Prescription drugs only",
  },
  "ORTHOLEEN HOT GEL": {
    composition: "Each gm contains Diclofenac Diethylamine 1.16% w/w (eq. to Diclofenac sodium 1% w/w), Linseed Oil 3% w/w, Menthol 5% w/w, Methyl salicylate 10% w/w, Capsaicin 0.025% w/w, Benzyl Alcohol 0.1% w/w",
    description: "Ortholeen Hot Gel contains Diclofenac (NSAID) with Linseed oil, Menthol, Methyl salicylate and Capsaicin. Used for muscle and joint pain, sprains, strains, sports injuries, back pain, and osteoarthritis.",
    status: "Prescription drugs only",
  },
  "KN-CIT-5": {
    composition: "Each gm contains Clobetasole Propionate 0.05% w/w, Neomycin Sulphate 0.1% w/w, Tolnaftate 1% w/w, Iodochlor hydroxyquinoline 1% w/w, Ketoconazole 2% w/w, Dexpanthenol 0.5% w/w",
    description: "KN-Cit-5 cream contains Ketoconazole (antifungal), Neomycin (antibiotic), Tolnaftate (antifungal), Clobetasol (corticosteroid) and Dexpanthenol. Used for skin infections involving fungi and bacteria with inflammation.",
    status: "Prescription drugs only",
  },
  // ── Health care › Liniment / Spray ────────────────────────────────────────
  "Bleenac Roll on": {
    composition: "Each ml contains Diclofenac Diethylamine 17.4mg, Menthol 50mg, Methyl salicylate 100mg, Camphor 10mg",
    description: "Bleenac Roll-on contains Diclofenac (topical NSAID), Methyl salicylate, Menthol and Camphor. Used for muscle and joint pain, sprains, strains, back pain, and sports injuries.",
    status: "Prescription drugs only",
  },
  "ORTHOLEEN SPRAY": {
    composition: "Each ml contains Diclofenac Diethylamine (eq. to Diclofenac Sodium), Methyl Salicylate, Linseed Oil and Menthol",
    description: "Ortholeen Spray contains Diclofenac, Methyl Salicylate, Linseed Oil and Menthol in a propellant-based spray. Used for joint pain, muscle pain, back pain, sprains, strains, and sports injuries.",
    status: "Prescription drugs only",
  },
  "BLEFRESH": {
    composition: "Contains Chlorhexidine Gluconate, Sodium Fluoride and Zinc Chloride",
    description: "Blefresh Advanced Mouthwash contains Chlorhexidine Gluconate (antiseptic), Sodium Fluoride (enamel strengthener) and Zinc Chloride. Used for complete oral protection, fighting bacteria, reducing plaque, preventing cavities, and controlling bad breath.",
    status: "OTC",
  },
  // ── Neutraceuticals › Capsules ────────────────────────────────────────────
  "VITALEEN - H": {
    composition: "Each soft gelatin capsule contains Multivitamins, Multiminerals with Ginseng",
    description: "Vitaleen-H contains multivitamins, multiminerals and Ginseng (herbal adaptogen). Used to support overall health, improve energy levels, reduce fatigue, and enhance general wellbeing especially during stress or recovery.",
    status: "Prescription drugs only",
  },
  "VITMIT - SG": {
    composition: "Each soft gelatin capsule contains Ginseng, Multivitamins, Multiminerals with Antioxidant",
    description: "Vitmit-SG contains Ginseng, multivitamins, multiminerals and antioxidants. Used for general weakness, tiredness, poor nutrition, stress, and recovery after illness.",
    status: "Prescription drugs only",
  },
  "B VIT A & D": {
    composition: "Each soft gelatin capsule contains Vitamin A 6000 IU (1801 mcg) and Vitamin D3 1000 IU (25 mcg)",
    description: "BVit A&D contains Vitamin A and Vitamin D3. Used to support vision, immune function, bone health, and calcium absorption.",
    status: "Prescription drugs only",
  },
  "GARLIC": {
    composition: "Contains Garlic Satva (natural herbal extract)",
    description: "Garlic soft gelatin capsules contain Garlic Satva, a natural herbal extract. Used to support heart health, maintain healthy cholesterol levels, improve blood circulation, strengthen immunity, and support metabolic health.",
    status: "OTC",
  },
  "GO PILEEN": {
    composition: "Contains Senna (Sannai), Haritaki, Castor (Erand), Bilva, Neem, Punarnava, Aloe vera and other herbal extracts",
    description: "Go Pileen capsules contain a blend of herbal ingredients including Senna, Haritaki, Castor, Bilva and Aloe vera. Used to support natural bowel movement, relieve constipation, and promote gentle detoxification of the body.",
    status: "OTC",
  },
  // ── Neutraceuticals › Syrup ───────────────────────────────────────────────
  "VITALEEN drops": {
    composition: "Each 5ml contains Multivitamins with iron",
    description: "Vitaleen drops contain multivitamins with iron. Used in infants and children for nutritional deficiency, energy support, brain development, and iron deficiency anaemia prevention.",
    status: "Prescription drugs only",
  },
  "VITALEEN SYRUP": {
    composition: "Each 5ml contains Multivitamins, Multiminerals and Antioxidants",
    description: "Vitaleen syrup contains multivitamins, multiminerals and antioxidants. Used as a dietary supplement for nutritional deficiencies, immunity, energy, brain and nerve function, and overall body wellness.",
    status: "Prescription drugs only",
  },
  "BLEELIV": {
    composition: "Contains herbal liver-protective ingredients",
    description: "Bleeliv syrup is a hepatoprotective supplement containing herbal extracts. Used to support liver health, aid in liver detoxification, and improve digestive function.",
    status: "OTC",
  },
  "HARRYPOWER": {
    composition: "Contains Shatavari (Asparagus racemosus), Ashwagandha (Withania somnifera), Guduchi, Gokshura (Tribulus terrestris), Kapikacchu (Mucuna pruriens), Safed Musli, Kali Musli, Trikatu and other herbal extracts",
    description: "HarryPower syrup is a herbal vitality and strength formula. Used to enhance overall vitality, improve physical strength, support stamina, reduce fatigue, improve energy levels, and support reproductive and hormonal health.",
    status: "OTC",
  },
  "TULEE CURE": {
    composition: "Contains Tulsi (Ocimum sanctum), Chitharathai, Adathodai (Adhatoda vasica), Licorice, Turmeric, Thandrikkai, Kadukkai (Terminalia chebula), Amla and other herbal extracts",
    description: "Tulee Cure syrup is a herbal immunity and respiratory support formula. Used to support respiratory health, improve immunity, and provide relief from cough, cold, throat irritation, and mild respiratory discomfort.",
    status: "OTC",
  },
  // ── Neutraceuticals › Ointment / Cream ────────────────────────────────────
  "ORTHOLEEN Active Oil": {
    composition: "Contains Shorea robusta (Sal tree), Cardiospermum halicacabum (Mudakathan), Sida cordifolia (Bala), Eucalyptus oil, Sesame oil and Castor oil",
    description: "Ortholeen Active Oil is a herbal pain relief and anti-inflammatory formula. Used for relief from joint pain, muscle pain, inflammation, stiffness, and swelling in arthritis, back pain, and muscular fatigue.",
    status: "OTC",
  },
  "FLEXILEEN": {
    composition: "Contains Vatakesari Thailam, Nilgiri Thailam (Eucalyptus oil), Citramutthi Thailam, Karporam (Camphor) and Kuntrikam Thailam",
    description: "Flexileen is a herbal pain relief and joint care oil. Used in traditional practice for relief from joint pain, muscle pain, stiffness, and inflammation. Helps improve blood circulation and supports mobility.",
    status: "OTC",
  },
  "HEALEEN": {
    composition: "Contains Daruhaldi (Berberis aristata), Pashanbhed, Jivanti, Manjistha, Kampillaka, Haldi (Curcuma longa), Isabgol and Ral",
    description: "Healeen Foot Crack Cream is a herbal foot care formulation. Used for healing cracked heels and dry, rough skin. Helps repair deep cracks, moisturize hardened skin, and promote faster healing.",
    status: "OTC",
  },
  // ── Neutraceuticals › Liniment / Spray ───────────────────────────────────
  "ADVANCE ORTHOLEEN ROLL ON": {
    composition: "Contains Camphor (Karpur), Menthol (Pudina Satva), Ajwain Satva, Eucalyptus oil, Wintergreen oil (Gaultheria), Capsicum Oil, Lemongrass Oil, Cajeput Oil, Clove Oil, Almond Oil, Shallaki (Boswellia) and Cinnamon oil",
    description: "Advance Ortholeen Roll-On is a herbal fast-acting analgesic oil. Provides fast and effective relief from muscular pain, joint pain, back pain, sprains, and stiffness. Reduces inflammation and relaxes muscles.",
    status: "OTC",
  },
  // ── Neutraceuticals › Herbal Tablets ─────────────────────────────────────
  "Kabasura kudineer": {
    composition: "Contains Nilavembu, Chukku, Thippili, Kadukkai, Adathodai and other traditional Siddha herbs",
    description: "Kabasura Kudineer Chooranam is a traditional Siddha herbal formulation. Used as part of a daily wellness routine to support general health, strengthen the body's natural defense system, and maintain overall wellbeing.",
    status: "OTC",
  },
  "Nilavembu kudineer": {
    composition: "Contains Nilavembu (Andrographis paniculata) and other potent herbs",
    description: "Nilavembu Kudineer Choornam is a traditional Siddha herbal formulation. Used for immunity-boosting, fever support, fighting seasonal infections, and detoxifying the body.",
    status: "OTC",
  },
  "ALUM VELUM TOOTH POWDER": {
    composition: "Contains Acacia catechu (Khadir), Terminalia chebula (Haritaki), Emblica officinalis (Amla), Terminalia bellerica (Bibhitaki), Eugenia caryophyllata (Clove), Zingiber officinale (Ginger), Piper nigrum (Black pepper) and Piper longum (Long pepper)",
    description: "Alum Velum Tooth Powder is a herbal oral care formulation. Used to strengthen gums, reduce tooth sensitivity, prevent bad breath, and protect against cavities and plaque buildup.",
    status: "OTC",
  },
  "ALUM VELUM TOOTH PASTE": {
    composition: "Contains Acacia catechu (Khadir), Terminalia chebula (Haritaki), Emblica officinalis (Amla), Terminalia bellerica (Bibhitaki), Clove, Ginger, Black pepper and Long pepper",
    description: "Alum Velum Tooth Paste is a herbal toothpaste. Used for complete oral hygiene, strengthening gums, reducing sensitivity, preventing bad breath, and protecting against cavities.",
    status: "OTC",
  },
  // ── Neutraceuticals › Tablets ─────────────────────────────────────────────
  "SLIMLEEN PLUS - Tablets": {
    composition: "Each film coated tablet contains Garcinia cambogia 500mg, Licorice root 500mg, Green tea extract 65mg, Zingiber officinale 35mg, Piper longum extract 11mg",
    description: "Slimleen Plus contains Garcinia cambogia, Licorice, Green tea extract (antioxidant), Ginger, and Piper longum. Used for weight management, metabolism support, and digestive health.",
    status: "Prescription drugs only",
  },
  "MULTILEEN FORTE - Tablets": {
    composition: "Each film coated tablet contains Multivitamins with Amino acids and Minerals",
    description: "Multileen Forte is a multivitamin supplement with amino acids and minerals. Used to prevent or treat nutritional deficiencies, improve strength, support immunity, enhance recovery after illness or surgery, and reduce fatigue.",
    status: "Prescription drugs only",
  },
  "ZINCOLEEN - Tablets": {
    composition: "Each tablet contains Zinc (as Zinc gluconate or Zinc sulphate) with supporting vitamins",
    description: "Zincoleen tablets contain Zinc, an essential mineral. Used for zinc deficiency, immune support, wound healing, and overall metabolic health.",
    status: "Prescription drugs only",
  },
  // ── Cosmetics › Skin & Hair ───────────────────────────────────────────────
  "LOVELEEN GOLD SOAP": {
    composition: "Premium herbal soap with gold extract and skin nourishing ingredients",
    description: "Loveleen Gold Soap is a premium herbal bathing soap enriched with gold extract. Provides gentle cleansing, skin nourishment, and a luxurious bathing experience.",
    status: "OTC",
  },
  "LOVELEEN SANDAL TALCUM": {
    composition: "Contains Sandalwood extract, Talcum powder base",
    description: "Loveleen South Asian Sandal Talcum Powder is infused with the rich essence of sandalwood. Keeps skin cool, dry, and comfortable throughout the day while delivering a pleasant, long-lasting aroma.",
    status: "OTC",
  },
  "LOVELEEN COOL COOL BODY POWDER": {
    composition: "Contains mint-based cooling formula with talcum base",
    description: "Loveleen Ice Fresh Cool Cool Body Powder is formulated with a refreshing mint-based cooling formula. Delivers an instant icy sensation, absorbs excess sweat, controls body odour, and keeps skin dry.",
    status: "OTC",
  },
  "LOVELEEN SANDAL GLYCERIN SOAP": {
    composition: "Contains Sandalwood, Glycerin and Aloe vera extract",
    description: "Loveleen Luxury Glycerin Sandal Soap is infused with Aloe vera, Glycerin and sandalwood. Provides deep hydration and gentle cleansing without stripping natural moisture. Suitable for all skin types.",
    status: "OTC",
  },
  "LOVELEEN ELEGANT SANDAL SOAP": {
    composition: "Contains Sandalwood extract, Aloe vera extract and Glycerin",
    description: "Loveleen Elegant Sandal Soap is enriched with Aloe vera and moisturizing glycerin. Gently cleanses skin while maintaining natural moisture balance. Leaves skin soft, smooth, and delicately scented.",
    status: "OTC",
  },
  "GAL-ACLEN": {
    composition: "Contains cleansing and anti-acne herbal ingredients",
    description: "Gal Aclen is specially designed for acne-prone skin. Helps remove dirt, excess oil, and impurities that clog pores. Works to reduce acne-causing factors while maintaining skin's natural balance.",
    status: "OTC",
  },
  "KETALEEN": {
    composition: "Contains gentle cleansing ingredients with skin-care actives",
    description: "Ketaleen Soap is a gentle cleansing bar for daily use. Helps remove dirt, oil, and impurities from the skin, leaving it clean and refreshed. Suitable for all skin types.",
    status: "OTC",
  },
  "SCABLEEN": {
    composition: "Contains Permethrin, Neem Oil and Glycerin",
    description: "Scableen Soap is made with Permethrin, Neem Oil and Glycerin. Designed for everyday skin cleansing with a rich lather for a fresh, clean feel.",
    status: "Prescription drugs only",
  },
  "TARLEEN": {
    composition: "Contains activated charcoal with cleansing base",
    description: "Tarleen Charcoal Soap is enriched with activated charcoal. Helps draw out dirt, toxins, and excess oil from skin. Provides antibacterial and exfoliating properties for acne control and clear, healthy skin.",
    status: "OTC",
  },
  "ALOE TULEE": {
    composition: "Contains Aloe Vera extract with herbal cleansing base",
    description: "Aloe Tulee Herbal Soap is crafted with the goodness of Aloe Vera. Provides gentle cleansing and natural skin nourishment, maintaining hydration while protecting against dryness.",
    status: "OTC",
  },
  "MOIXY SOAP": {
    composition: "Contains Aloe Vera 1.00%, Natural Vitamin E 0.50%, Calendula, Marigold, Thuja and Moisturiser Cream 2.00%",
    description: "MOIXY Moisturizing Soap is a 100gm herbal bath soap formulated to deeply hydrate and nourish skin. Enriched with Aloe Vera, Vitamin E and herbal extracts, it provides excellent skin hydration for dry skin.",
    status: "OTC",
  },
  "DEARA BABY CARE": {
    composition: "Contains Creamy Milk and Shea Butter with gentle cleansing base",
    description: "Deara Baby Care Soap contains Creamy Milk and Shea Butter. Designed for gentle cleansing to keep baby skin soft and comfortable after every wash. Mild formula suitable for regular daily use.",
    status: "OTC",
  },
  // ── Cosmetics › Hair Care ─────────────────────────────────────────────────
  "LOVELEEN THARIGAI HAIR OIL": {
    composition: "Contains Brahmi, Bhringraj, Hibiscus, Neem, Coconut Oil, Almond Oil, Olive Oil, Indian Gooseberry and other herbal extracts",
    description: "Loveleen Tharigai Multiherb Hair Oil is an Ayurvedic proprietary formulation. Nourishes the scalp, strengthens hair from root to tip, moisturizes dry scalp, reduces dandruff, and improves hair texture and natural shine.",
    status: "OTC",
  },
  "LOVELEEN LYCIL (Lice Control Oil)": {
    composition: "Ayurvedic proprietary herbal oil formulation for lice control",
    description: "Loveleen Lycil Lice Control Oil is an Ayurvedic proprietary oil specially formulated to help control head lice and support a clean, healthy scalp. Soothes itching, reduces scalp discomfort, and maintains hair hygiene.",
    status: "OTC",
  },
  "LOVELEEN PODUKAI (Dandruff Relief Oil)": {
    composition: "Contains Coconut Oil, Mimusops elengi, Citrus medica, Tulsi, Indigofera tinctoria (Neeli), Cynodon dactylon, Psoralea corylifolia (Bakuchi), Curcuma longa (Turmeric) and other herbal extracts",
    description: "Loveleen Podukai Dandruff Relief Oil is a herbal anti-dandruff and scalp care formula. Helps reduce itching, flaking, and scalp irritation while providing deep nourishment to hair roots.",
    status: "OTC",
  },
  // ── Veterinary ────────────────────────────────────────────────────────────
  "PETLEEN": {
    composition: "Contains Neem extract, antibacterial ingredients and Glycerin",
    description: "Petleen Pet Soap is specially crafted for pet hygiene. Enriched with Neem extract and antibacterial ingredients to help remove dirt, odour, fleas, ticks, and skin-irritating pests. Keeps pet coat clean, soft, and manageable.",
    status: "OTC",
  },
};

// ─── Products ─────────────────────────────────────────────────────────────────
const PRODUCTS = [
  // ── Health care › Tablets ──────────────────────────────────────────────────
  { name: "ATOLEEN-10",               division: "Health care", category: "Tablets", chemical_category: "Anti Hypertensive / Sedatives", formulation: "Tablet" },
  { name: "B-MET-500",                division: "Health care", category: "Tablets", chemical_category: "Anti Diabetics",                formulation: "Tablet" },
  { name: "B-MET-G1",                 division: "Health care", category: "Tablets", chemical_category: "Anti Diabetics",                formulation: "Tablet" },
  { name: "B-MET-G2",                 division: "Health care", category: "Tablets", chemical_category: "Anti Diabetics",                formulation: "Tablet" },
  { name: "B-MET-TRIO 2mg",           division: "Health care", category: "Tablets", chemical_category: "Anti Diabetics",                formulation: "Tablet" },
  { name: "BLECAL-D3",                division: "Health care", category: "Tablets", chemical_category: "",                              formulation: "Tablet" },
  { name: "BLEGESIC - P",             division: "Health care", category: "Tablets", chemical_category: "Analgesics",                    formulation: "Tablet" },
  { name: "BLEMOL-250",               division: "Health care", category: "Tablets", chemical_category: "Analgesics",                    formulation: "Tablet" },
  { name: "BLEMOL - 500",             division: "Health care", category: "Tablets", chemical_category: "Analgesics",                    formulation: "Tablet" },
  { name: "BLEMOL - 650",             division: "Health care", category: "Tablets", chemical_category: "Analgesics",                    formulation: "Tablet" },
  { name: "BLEENAC",                  division: "Health care", category: "Tablets", chemical_category: "Analgesics",                    formulation: "Tablet" },
  { name: "BLEESPAS",                 division: "Health care", category: "Tablets", chemical_category: "Analgesics",                    formulation: "Tablet" },
  { name: "BLEECOLD",                 division: "Health care", category: "Tablets", chemical_category: "Anti Cold",                     formulation: "Tablet" },
  { name: "BLEECOLD PLUS",            division: "Health care", category: "Tablets", chemical_category: "Anti Cold",                     formulation: "Tablet" },
  { name: "BLEPRAX - 0.25",           division: "Health care", category: "Tablets", chemical_category: "Anti Hypertensive / Sedatives", formulation: "Tablet" },
  { name: "BLEPRAX - 0.5",            division: "Health care", category: "Tablets", chemical_category: "Anti Hypertensive / Sedatives", formulation: "Tablet" },
  { name: "BLEEMOX CV 625",           division: "Health care", category: "Tablets", chemical_category: "Anti Biotics",                  formulation: "Tablet" },
  { name: "BLECEF-O 200",             division: "Health care", category: "Tablets", chemical_category: "Anti Biotics",                  formulation: "Tablet" },
  { name: "BLEECET",                  division: "Health care", category: "Tablets", chemical_category: "Anti Histaminics",              formulation: "Tablet" },
  { name: "CIPROLEEN-250",            division: "Health care", category: "Tablets", chemical_category: "Anti Biotics",                  formulation: "Tablet" },
  { name: "CIPROLEEN-500",            division: "Health care", category: "Tablets", chemical_category: "Anti Biotics",                  formulation: "Tablet" },
  { name: "CETLEEN",                  division: "Health care", category: "Tablets", chemical_category: "Anti Histaminics",              formulation: "Tablet" },
  { name: "GALCOLD",                  division: "Health care", category: "Tablets", chemical_category: "Anti Cold",                     formulation: "Tablet" },
  { name: "GALGESIC",                 division: "Health care", category: "Tablets", chemical_category: "Analgesics",                    formulation: "Tablet" },
  { name: "GALGESIC MR",              division: "Health care", category: "Tablets", chemical_category: "Analgesics",                    formulation: "Tablet" },
  { name: "GALGESIC SP",              division: "Health care", category: "Tablets", chemical_category: "Analgesics",                    formulation: "Tablet" },
  { name: "MONTLEEN-LC",              division: "Health care", category: "Tablets", chemical_category: "Anti Histaminics",              formulation: "Tablet" },
  { name: "BLECEF-200",               division: "Health care", category: "Tablets", chemical_category: "Anti Biotics",                  formulation: "Tablet" },
  { name: "NIMLEEN (Blue,Brown,Yellow)", division: "Health care", category: "Tablets", chemical_category: "",                           formulation: "Tablet" },
  { name: "NEUROLEEN FORTE",          division: "Health care", category: "Tablets", chemical_category: "Neuron Rejuvenators",           formulation: "Tablet" },
  { name: "PANTOLIK-40",              division: "Health care", category: "Tablets", chemical_category: "Anti Ulcer",                    formulation: "Tablet" },
  { name: "PANTOLIK - D",             division: "Health care", category: "Tablets", chemical_category: "Anti Ulcer",                    formulation: "Tablet" },
  { name: "RANLEE-150",               division: "Health care", category: "Tablets", chemical_category: "Anti Ulcer",                    formulation: "Tablet" },
  { name: "TELMILEEN-40",             division: "Health care", category: "Tablets", chemical_category: "Anti Hypertensive / Sedatives", formulation: "Tablet" },
  { name: "TELMILEEN-H",              division: "Health care", category: "Tablets", chemical_category: "Anti Hypertensive / Sedatives", formulation: "Tablet" },
  // ── Health care › Capsules ────────────────────────────────────────────────
  { name: "BLEMOX 250",               division: "Health care", category: "Capsules", chemical_category: "Anti Biotics",                 formulation: "Capsule" },
  { name: "BLEMOX-500",               division: "Health care", category: "Capsules", chemical_category: "Anti Biotics",                 formulation: "Capsule" },
  { name: "BLECLOX - LB",             division: "Health care", category: "Capsules", chemical_category: "Anti Biotics",                 formulation: "Capsule" },
  { name: "MECOBALEEN PLUS",          division: "Health care", category: "Capsules", chemical_category: "Neuron Rejuvenators",          formulation: "Capsule" },
  { name: "OMELEE-20",                division: "Health care", category: "Capsules", chemical_category: "Anti Ulcer",                   formulation: "Capsule" },
  { name: "PANTOLIK - DSR",           division: "Health care", category: "Capsules", chemical_category: "Anti Ulcer",                   formulation: "Capsule" },
  { name: "RABLEEN-DSR",              division: "Health care", category: "Capsules", chemical_category: "Anti Ulcer",                   formulation: "Capsule" },
  { name: "BRELEEN",                  division: "Health care", category: "Capsules", chemical_category: "",                             formulation: "Capsule" },
  { name: "ELEEN 400",                division: "Health care", category: "Capsules", chemical_category: "",                             formulation: "Capsule" },
  { name: "K.COFF-SG",               division: "Health care", category: "Capsules", chemical_category: "Anti Cold",                    formulation: "Capsule" },
  { name: "Neu 1 Forte",              division: "Health care", category: "Capsules", chemical_category: "Neuron Rejuvenators",          formulation: "Capsule" },
  { name: "FATAXY 3 - Capsules",      division: "Health care", category: "Capsules", chemical_category: "",                             formulation: "Capsule" },
  // ── Health care › Syrup ───────────────────────────────────────────────────
  { name: "ALKALEEN Liquid",          division: "Health care", category: "Syrup",    chemical_category: "",                             formulation: "Liquid"  },
  { name: "ALAXY (Expectorant)",      division: "Health care", category: "Syrup",    chemical_category: "Anti Cold",                    formulation: "Syrup"   },
  { name: "ALAXY - DX (Expectorant)", division: "Health care", category: "Syrup",    chemical_category: "Anti Cold",                    formulation: "Syrup"   },
  { name: "BLEECID MPS (Mint, Elachi)", division: "Health care", category: "Syrup",  chemical_category: "Anti Ulcer",                   formulation: "Syrup"   },
  { name: "BLEEDRYL (Expectorant)",   division: "Health care", category: "Syrup",    chemical_category: "Anti Cold",                    formulation: "Syrup"   },
  { name: "BLECAL-D3 Syrup",         division: "Health care", category: "Syrup",    chemical_category: "",                             formulation: "Syrup"   },
  { name: "BLEMOL - 125",             division: "Health care", category: "Syrup",    chemical_category: "Analgesics",                   formulation: "Syrup"   },
  { name: "BLEMOL - 250 Syrup",       division: "Health care", category: "Syrup",    chemical_category: "Analgesics",                   formulation: "Syrup"   },
  { name: "BLEMOL-500 Syrup",         division: "Health care", category: "Syrup",    chemical_category: "Analgesics",                   formulation: "Syrup"   },
  { name: "BLEMOL - M",               division: "Health care", category: "Syrup",    chemical_category: "Analgesics",                   formulation: "Syrup"   },
  { name: "BLECOLD Syrup",            division: "Health care", category: "Syrup",    chemical_category: "Anti Cold",                    formulation: "Syrup"   },
  { name: "BLEECOLD DROPS",           division: "Health care", category: "Syrup",    chemical_category: "Anti Cold",                    formulation: "Drops"   },
  { name: "BLEEZYME - Syrup",         division: "Health care", category: "Syrup",    chemical_category: "",                             formulation: "Syrup"   },
  { name: "BLEPLEX",                  division: "Health care", category: "Syrup",    chemical_category: "",                             formulation: "Syrup"   },
  { name: "CETLEEN Syrup",            division: "Health care", category: "Syrup",    chemical_category: "Anti Histaminics",             formulation: "Syrup"   },
  { name: "FERRILEEN",                division: "Health care", category: "Syrup",    chemical_category: "",                             formulation: "Syrup"   },
  { name: "K-COFF D",                 division: "Health care", category: "Syrup",    chemical_category: "Anti Cold",                    formulation: "Syrup"   },
  { name: "K-COFF-LS",                division: "Health care", category: "Syrup",    chemical_category: "Anti Cold",                    formulation: "Syrup"   },
  { name: "MONTLEEN-LC Syrup",        division: "Health care", category: "Syrup",    chemical_category: "Anti Histaminics",             formulation: "Syrup"   },
  { name: "SUCRALEEN",                division: "Health care", category: "Syrup",    chemical_category: "",                             formulation: "Syrup"   },
  { name: "SUCRALEEN-O",              division: "Health care", category: "Syrup",    chemical_category: "",                             formulation: "Syrup"   },
  { name: "Blemol Drops",             division: "Health care", category: "Syrup",    chemical_category: "Analgesics",                   formulation: "Drops"   },
  // ── Health care › Injections ──────────────────────────────────────────────
  { name: "B-NEURON",                 division: "Health care", category: "Injections", chemical_category: "",                           formulation: "Injection" },
  { name: "B-NEURON FORTE",           division: "Health care", category: "Injections", chemical_category: "",                           formulation: "Injection" },
  { name: "PANTOLIK - 40 inj",        division: "Health care", category: "Injections", chemical_category: "Anti Ulcer",                 formulation: "Injection" },
  // ── Health care › Ointment / Cream ────────────────────────────────────────
  { name: "BLEBACT",                  division: "Health care", category: "Ointment / Cream", chemical_category: "Ointment / Cream",      formulation: "Ointment" },
  { name: "IONIC-4",                  division: "Health care", category: "Ointment / Cream", chemical_category: "Ointment / Cream",      formulation: "Cream"    },
  { name: "ORTHOLEEN HOT GEL",        division: "Health care", category: "Ointment / Cream", chemical_category: "Ointment / Cream",      formulation: "Gel"      },
  { name: "KN-CIT-5",                 division: "Health care", category: "Ointment / Cream", chemical_category: "Ointment / Cream",      formulation: "Cream"    },
  // ── Health care › Liniment / Spray ────────────────────────────────────────
  { name: "Bleenac Roll on",          division: "Health care", category: "Liniment / Spray", chemical_category: "",                      formulation: "Roll-on"   },
  { name: "ORTHOLEEN SPRAY",          division: "Health care", category: "Liniment / Spray", chemical_category: "",                      formulation: "Spray"     },
  { name: "BLEFRESH",                 division: "Health care", category: "Liniment / Spray", chemical_category: "",                      formulation: "Mouthwash" },
  // ── Neutraceuticals › Capsules ────────────────────────────────────────────
  { name: "VITALEEN - H",             division: "Neutraceuticals", category: "Capsules", chemical_category: "",                          formulation: "Capsule" },
  { name: "VITMIT - SG",              division: "Neutraceuticals", category: "Capsules", chemical_category: "",                          formulation: "Capsule" },
  { name: "B VIT A & D",              division: "Neutraceuticals", category: "Capsules", chemical_category: "",                          formulation: "Capsule" },
  { name: "GARLIC",                   division: "Neutraceuticals", category: "Capsules", chemical_category: "",                          formulation: "Capsule" },
  { name: "GO PILEEN",                division: "Neutraceuticals", category: "Capsules", chemical_category: "",                          formulation: "Capsule" },
  // ── Neutraceuticals › Syrup ───────────────────────────────────────────────
  { name: "VITALEEN drops",           division: "Neutraceuticals", category: "Syrup",    chemical_category: "",                          formulation: "Drops"   },
  { name: "VITALEEN SYRUP",           division: "Neutraceuticals", category: "Syrup",    chemical_category: "",                          formulation: "Syrup"   },
  { name: "BLEELIV",                  division: "Neutraceuticals", category: "Syrup",    chemical_category: "",                          formulation: "Syrup"   },
  { name: "HARRYPOWER",               division: "Neutraceuticals", category: "Syrup",    chemical_category: "",                          formulation: "Syrup"   },
  { name: "TULEE CURE",               division: "Neutraceuticals", category: "Syrup",    chemical_category: "",                          formulation: "Syrup"   },
  // ── Neutraceuticals › Ointment / Cream ───────────────────────────────────
  { name: "ORTHOLEEN Active Oil",     division: "Neutraceuticals", category: "Ointment / Cream", chemical_category: "",                   formulation: "Oil"     },
  { name: "FLEXILEEN",                division: "Neutraceuticals", category: "Ointment / Cream", chemical_category: "",                   formulation: "Cream"   },
  { name: "HEALEEN",                  division: "Neutraceuticals", category: "Ointment / Cream", chemical_category: "",                   formulation: "Cream"   },
  // ── Neutraceuticals › Liniment / Spray ───────────────────────────────────
  { name: "ADVANCE ORTHOLEEN ROLL ON", division: "Neutraceuticals", category: "Liniment / Spray", chemical_category: "",                  formulation: "Roll-on" },
  // ── Neutraceuticals › Herbal tablets ─────────────────────────────────────
  { name: "Kabasura kudineer",        division: "Neutraceuticals", category: "Tablets", chemical_category: "",                            formulation: "Herbal Powder" },
  { name: "Nilavembu kudineer",       division: "Neutraceuticals", category: "Tablets", chemical_category: "",                            formulation: "Herbal Powder" },
  { name: "ALUM VELUM TOOTH POWDER",  division: "Neutraceuticals", category: "Tablets", chemical_category: "",                            formulation: "Powder"        },
  { name: "ALUM VELUM TOOTH PASTE",   division: "Neutraceuticals", category: "Tablets", chemical_category: "",                            formulation: "Paste"         },
  { name: "SLIMLEEN PLUS - Tablets",  division: "Neutraceuticals", category: "Tablets", chemical_category: "",                            formulation: "Tablet"        },
  { name: "MULTILEEN FORTE - Tablets", division: "Neutraceuticals", category: "Tablets", chemical_category: "",                           formulation: "Tablet"        },
  { name: "ZINCOLEEN - Tablets",      division: "Neutraceuticals", category: "Tablets", chemical_category: "",                            formulation: "Tablet"        },
  // ── Cosmetics › Skin & Hair ───────────────────────────────────────────────
  { name: "LOVELEEN GOLD SOAP",                   division: "Cosmetics", category: "Skin & Hair", chemical_category: "", formulation: "Soap"   },
  { name: "LOVELEEN SANDAL TALCUM",               division: "Cosmetics", category: "Skin & Hair", chemical_category: "", formulation: "Powder" },
  { name: "LOVELEEN COOL COOL BODY POWDER",       division: "Cosmetics", category: "Skin & Hair", chemical_category: "", formulation: "Powder" },
  { name: "LOVELEEN SANDAL GLYCERIN SOAP",        division: "Cosmetics", category: "Skin & Hair", chemical_category: "", formulation: "Soap"   },
  { name: "LOVELEEN ELEGANT SANDAL SOAP",         division: "Cosmetics", category: "Skin & Hair", chemical_category: "", formulation: "Soap"   },
  { name: "GAL-ACLEN",                            division: "Cosmetics", category: "Skin & Hair", chemical_category: "", formulation: "Cream"  },
  { name: "KETALEEN",                             division: "Cosmetics", category: "Skin & Hair", chemical_category: "", formulation: "Cream"  },
  { name: "SCABLEEN",                             division: "Cosmetics", category: "Skin & Hair", chemical_category: "", formulation: "Cream"  },
  { name: "TARLEEN",                              division: "Cosmetics", category: "Skin & Hair", chemical_category: "", formulation: "Lotion" },
  { name: "ALOE TULEE",                           division: "Cosmetics", category: "Skin & Hair", chemical_category: "", formulation: "Gel"    },
  { name: "MOIXY SOAP",                           division: "Cosmetics", category: "Skin & Hair", chemical_category: "", formulation: "Soap"   },
  { name: "DEARA BABY CARE",                      division: "Cosmetics", category: "Skin & Hair", chemical_category: "", formulation: "Cream"  },
  // ── Cosmetics › Hair Care ─────────────────────────────────────────────────
  { name: "LOVELEEN THARIGAI HAIR OIL",           division: "Cosmetics", category: "Hair Care", chemical_category: "", formulation: "Oil" },
  { name: "LOVELEEN LYCIL (Lice Control Oil)",    division: "Cosmetics", category: "Hair Care", chemical_category: "", formulation: "Oil" },
  { name: "LOVELEEN PODUKAI (Dandruff Relief Oil)", division: "Cosmetics", category: "Hair Care", chemical_category: "", formulation: "Oil" },
  // ── Veterinary ────────────────────────────────────────────────────────────
  { name: "PETLEEN",                  division: "Veterinary",  category: "Petleen",  chemical_category: "", formulation: "" },
  // ── Self Care › DAY CARE ──────────────────────────────────────────────────
  { name: "BLEEN ADULT DIAPER",                   division: "Self Care", category: "DAY CARE Antiseptic Disinfectant Liquid", chemical_category: "", formulation: "" },
  { name: "BLEEN PREMIUM PANT ADULT DIAPER",      division: "Self Care", category: "DAY CARE Antiseptic Disinfectant Liquid", chemical_category: "", formulation: "" },
  { name: "BLEEN PREMIUM UNDERPADS",              division: "Self Care", category: "DAY CARE Antiseptic Disinfectant Liquid", chemical_category: "", formulation: "" },
  { name: "BEES BABY DIAPER",                     division: "Self Care", category: "DAY CARE Antiseptic Disinfectant Liquid", chemical_category: "", formulation: "" },
  { name: "BEES NEW BORN",                        division: "Self Care", category: "DAY CARE Antiseptic Disinfectant Liquid", chemical_category: "", formulation: "" },
  { name: "BLEEN GLO BABY WIPES",                 division: "Self Care", category: "DAY CARE Antiseptic Disinfectant Liquid", chemical_category: "", formulation: "" },
  { name: "BLEEN COOL BATH WIPES 32CM X32CM",     division: "Self Care", category: "DAY CARE Antiseptic Disinfectant Liquid", chemical_category: "", formulation: "" },
  { name: "BEES BABY DRY PANTS",                  division: "Self Care", category: "DAY CARE Antiseptic Disinfectant Liquid", chemical_category: "", formulation: "" },
  { name: "VELVENA NAPKIN",                       division: "Self Care", category: "DAY CARE Antiseptic Disinfectant Liquid", chemical_category: "", formulation: "" },
  { name: "Day Care Hand Sanitizer",              division: "Self Care", category: "DAY CARE Antiseptic Disinfectant Liquid", chemical_category: "", formulation: "Liquid" },
  { name: "Day Care Hand Wash Rose, Neem & Aloevera", division: "Self Care", category: "DAY CARE Antiseptic Disinfectant Liquid", chemical_category: "", formulation: "Liquid" },
  { name: "Day Care Hand Wash Lavender, Orange",  division: "Self Care", category: "DAY CARE Antiseptic Disinfectant Liquid", chemical_category: "", formulation: "Liquid" },
  { name: "Day Care Bath Wipes 15X20 32X22",      division: "Self Care", category: "DAY CARE Antiseptic Disinfectant Liquid", chemical_category: "", formulation: "" },
  { name: "Day Care Disposable Masks",            division: "Self Care", category: "DAY CARE Antiseptic Disinfectant Liquid", chemical_category: "", formulation: "" },
  // ── Surgical › Ortho Rehab ────────────────────────────────────────────────
  { name: "Abdominal Belt",           division: "Surgical", category: "Ortho Rehab",   chemical_category: "", formulation: "" },
  { name: "Cervical Collar",          division: "Surgical", category: "Ortho Rehab",   chemical_category: "", formulation: "" },
  { name: "L.S Belt",                 division: "Surgical", category: "Ortho Rehab",   chemical_category: "", formulation: "" },
  { name: "Contoured LS",             division: "Surgical", category: "Ortho Rehab",   chemical_category: "", formulation: "" },
  { name: "Rib Belt",                 division: "Surgical", category: "Ortho Rehab",   chemical_category: "", formulation: "" },
  { name: "Wrist Support",            division: "Surgical", category: "Ortho Rehab",   chemical_category: "", formulation: "" },
  { name: "Knee Cap",                 division: "Surgical", category: "Ortho Rehab",   chemical_category: "", formulation: "" },
  { name: "Anklet Binder",            division: "Surgical", category: "Ortho Rehab",   chemical_category: "", formulation: "" },
  { name: "Anklet Support",           division: "Surgical", category: "Ortho Rehab",   chemical_category: "", formulation: "" },
  { name: "Vericose Vein Stockings",  division: "Surgical", category: "Ortho Rehab",   chemical_category: "", formulation: "" },
  // ── Surgical › Equipments ─────────────────────────────────────────────────
  { name: "WHEEL CHAIRS",             division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 809/809B",              division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 909J",                  division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 9118F / 9118TF",        division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 9119 F",                division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 809PC / 809J PC",       division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 954GC",                 division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 369BB / 369 BL",        division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 863LAJPF7",             division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 951B",                  division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 976 ABJ43",             division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 9001LBJ",               division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 609/609U/609GC/609GCU", division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 681",                   division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 699L",                  division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 7760046",               division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BLEEN WALKER",             division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "COMMODE CHAIR",            division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "COT & MATTRESS",           division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 460",                   division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 560",                   division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 461",                   division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 462",                   division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 472",                   division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 572",                   division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 474",                   division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 475",                   division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 478",                   division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 479",                   division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 476",                   division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 477",                   division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 690 L",                 division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 696 Gray",              division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 899",                   division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 897 Hand Brake",        division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 913",                   division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "BL 523",                   division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
  { name: "3 LEG",                    division: "Surgical", category: "Equipments",    chemical_category: "", formulation: "" },
];

// ─── helpers ──────────────────────────────────────────────────────────────────
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
const normalizeName = (value) => String(value || "").trim().toLowerCase();

const STEPS        = ["divisions", "categories", "chemicalCategories", "products"];
const STEP_LABELS  = { divisions: "Divisions", categories: "Product Categories", chemicalCategories: "Chemical / Therapeutic Categories", products: "Products" };
const STEP_COUNTS  = { divisions: DIVISIONS.length, categories: CATEGORIES.length, chemicalCategories: CHEMICAL_CATEGORIES.length, products: PRODUCTS.length };
const TOTAL_ITEMS  = DIVISIONS.length + CATEGORIES.length + CHEMICAL_CATEGORIES.length + PRODUCTS.length;

const DIV_COLOR = {
  "Health care":     "#2eb4b4",
  "Neutraceuticals": "#10b981",
  "Cosmetics":       "#ec4899",
  "Veterinary":      "#f59e0b",
  "Self Care":       "#174f9a",
  "Surgical":        "#ef4444",
};

// ─── FIXED safePost: returns structured result, never throws ──────────────────
async function safePost(path, body) {
  try {
    const data = await apiRequest(path, { method: "POST", body });
    return { ok: true, data };
  } catch (err) {
    // Extract message from error — handles string errors, {error}, {detail}, {name} etc.
    let msg = "";
    if (typeof err === "string") msg = err;
    else if (err?.message) msg = err.message;
    else msg = JSON.stringify(err);
    return { ok: false, error: msg };
  }
}

async function safePut(path, body) {
  try {
    const data = await apiRequest(path, { method: "PUT", body });
    return { ok: true, data };
  } catch (err) {
    let msg = "";
    if (typeof err === "string") msg = err;
    else if (err?.message) msg = err.message;
    else msg = JSON.stringify(err);
    return { ok: false, error: msg };
  }
}

// ─── FIXED fetchList: returns empty results on failure ───────────────────────
async function fetchList(path) {
  try {
    const results = [];
    let page = 1;
    let lastData = {};

    while (page <= 50) {
      const data = await apiRequest(path, { params: { page, page_size: 500 } });
      const pageResults = Array.isArray(data) ? data : (data.results || []);
      results.push(...pageResults);
      lastData = data;

      if (Array.isArray(data) || !data.next || pageResults.length === 0) break;
      page += 1;
    }

    return { ...lastData, results };
  } catch (err) {
    return { results: [], error: err?.message || "Unable to load existing records" };
  }
}

function findByName(rows, nameKey, name) {
  const target = normalizeName(name);
  return (rows || []).find((row) => normalizeName(row[nameKey]) === target);
}

// ─── FIXED: Robust duplicate detection – checks ALL common error patterns ─────
const IMAGE_FILE_RE = /\.(png|jpe?g|webp|gif)$/i;
const IMAGE_SUFFIX_RE = /^(tablet|tablets|capsule|capsules|syrup|injection|injections|inj|ointment|cream|gel|spray|liniment|oil|soap|powder|paste|liquid|drops|rollon|roll|on|expectorant|gray|grey|blue|brown|yellow|mint|elachi|lavender|orange|rose|neem|aloevera|newborn|baby|adult|premium|pant|pants|underpads|diaper|wipes|mask|masks|hand|wash|sanitizer|active|hot|forte|plus|gold|sandal|cool|body|glycerin|elegant|care|dry|bath|disposable|chair|chairs|walker|belt|collar|support|binder|stockings|brake|handbrake|gc|pc|jpc|tf|f|u|l|abj|lbj|lajpf|bb|bl|j|\d+)+$/;

function stripImageName(fileName) {
  return String(fileName || "")
    .replace(IMAGE_FILE_RE, "")
    .replace(/\(\d+\)\s*$/, "")
    .trim();
}

function normalizeForMatch(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/belcal/g, "blecal")
    .replace(/bleazyme/g, "bleezyme")
    .replace(/brleen/g, "breleen")
    .replace(/vericose/g, "varicose")
    .replace(/south\s*asian/g, "")
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "");
}

function uniqueValues(values) {
  return [...new Set(values.map((value) => String(value || "").trim()).filter(Boolean))];
}

function productAliases(productName) {
  const aliases = [productName];
  const withoutParens = String(productName || "").replace(/\([^)]*\)/g, " ").replace(/\s+/g, " ").trim();
  aliases.push(withoutParens);
  const strengthless = withoutParens.replace(/\b\d+\s*(mg|g|mcg|ml)?\b/gi, " ").replace(/\s+/g, " ").trim();
  if (normalizeForMatch(strengthless).length >= 5) aliases.push(strengthless);

  const slashParts = String(productName || "").split("/").map((part) => part.trim()).filter(Boolean);
  if (slashParts.length > 1) {
    const prefix = slashParts[0].match(/^([A-Za-z]+)\s+/)?.[1] || "";
    slashParts.forEach((part) => {
      aliases.push(part);
      if (prefix && !part.toLowerCase().startsWith(prefix.toLowerCase())) {
        aliases.push(`${prefix} ${part}`);
      }
    });
  }

  return uniqueValues(aliases);
}

function imageMatchScore(fileName, productName) {
  const imageKey = normalizeForMatch(stripImageName(fileName));
  if (!imageKey) return 0;

  return productAliases(productName).reduce((best, alias) => {
    const aliasKey = normalizeForMatch(alias);
    if (!aliasKey) return best;
    const lengthBonus = Math.min(aliasKey.length / 1000, 0.05);
    if (imageKey === aliasKey) return Math.max(best, 100 + lengthBonus);

    if (imageKey.startsWith(aliasKey)) {
      const suffix = imageKey.slice(aliasKey.length);
      return Math.max(best, (IMAGE_SUFFIX_RE.test(suffix) ? 90 : 70) + lengthBonus);
    }

    if (aliasKey.startsWith(imageKey) && imageKey.length >= 5) {
      return Math.max(best, 65 + lengthBonus);
    }

    if (imageKey.endsWith(aliasKey) && aliasKey.length >= 5) {
      return Math.max(best, 64 + lengthBonus);
    }

    return best;
  }, 0);
}

function matchImageToProduct(file, products) {
  const scored = products
    .map((product) => ({ product, score: imageMatchScore(file.name, product.name) }))
    .filter((item) => item.score > 0)
    .sort((a, b) => b.score - a.score);

  if (scored.length === 0) return { type: "unmatched" };
  if (scored.length > 1 && scored[0].score === scored[1].score) {
    return { type: "ambiguous", matches: scored.filter((item) => item.score === scored[0].score).map((item) => item.product.name) };
  }
  return { type: "matched", product: scored[0].product };
}

function isDuplicateError(errMsg) {
  if (!errMsg) return false;
  const lower = errMsg.toLowerCase();
  return (
    lower.includes("already") ||
    lower.includes("unique") ||
    lower.includes("exist") ||
    lower.includes("duplicate") ||
    lower.includes("constraint") ||
    lower.includes("violat") ||      // "violation", "violates"
    lower.includes("integrity")
  );
}

// ─── upsert: POST first, look up on duplicate, log real errors ───────────────
async function upsert(postPath, listPath, nameKey, body, label, addLog, setErrors) {
  const existingList = await fetchList(listPath);
  const existing = findByName(existingList?.results, nameKey, body[nameKey]);
  if (existing) {
    addLog(`  ~ skip (exists): ${label}`, "warn");
    return existing.id;
  }
  if (existingList.error) {
    addLog(`  ⚠ could not check existing ${label}: ${existingList.error}`, "warn");
  }

  const { ok, data, error } = await safePost(postPath, body);
  if (ok) {
    addLog(`  ✓ ${label}`);
    return data?.id ?? data?.data?.id ?? null;
  }
  // Duplicate → silent skip, look up the existing record
  if (isDuplicateError(error)) {
    const list = await fetchList(listPath);
    const found = findByName(list?.results, nameKey, body[nameKey]);
    if (found) {
      addLog(`  ~ skip (exists): ${label}`, "warn");
      return found.id;
    }
    // Duplicate error but couldn't find via list — still return null, log as warn
    addLog(`  ~ skip (exists, id unknown): ${label}`, "warn");
    return null;
  }
  // Genuine error
  addLog(`  ✗ failed: ${label} — ${error}`, "error");
  setErrors((prev) => [...prev, `${label}: ${error}`]);
  return null;
}

// ─── Component ────────────────────────────────────────────────────────────────
export default function BulkImporter() {
  const [running,     setRunning]     = useState(false);
  const [done,        setDone]        = useState(false);
  const [currentStep, setCurrentStep] = useState(null);
  const [progress,    setProgress]    = useState({ divisions: 0, categories: 0, chemicalCategories: 0, products: 0 });
  const [logs,        setLogs]        = useState([]);
  const [errors,      setErrors]      = useState([]);
  const [imageRunning, setImageRunning] = useState(false);
  const [imageProgress, setImageProgress] = useState({ matched: 0, uploaded: 0, total: 0 });
  const logsRef  = useRef(null);
  const imageInputRef = useRef(null);
  const abortRef = useRef(false);

  const addLog = (msg, type = "info") => {
    setLogs((prev) => [...prev, { msg, type, ts: Date.now() }]);
    setTimeout(() => { if (logsRef.current) logsRef.current.scrollTop = logsRef.current.scrollHeight; }, 40);
  };

  const run = async () => {
    setRunning(true); setDone(false);
    setLogs([]); setErrors([]);
    setProgress({ divisions: 0, categories: 0, chemicalCategories: 0, products: 0 });
    abortRef.current = false;

    const divIds  = {};
    const catIds  = {};
    const chemIds = {};
    const productIds = {};
    const existingProductByName = {};

    // ── 1. Divisions ──────────────────────────────────────────────────────────
    setCurrentStep("divisions");
    addLog("▶ Step 1 — Divisions");
    for (let i = 0; i < DIVISIONS.length; i++) {
      if (abortRef.current) break;
      const d = DIVISIONS[i];
      const id = await upsert(
        "/admin/divisions/", "/admin/divisions/", "name",
        { name: d.name, tag: d.tag },
        `Division: ${d.name}`,
        addLog, setErrors
      );
      if (id) divIds[d.name] = id;
      setProgress((p) => ({ ...p, divisions: i + 1 }));
      await sleep(80);
    }

    // ── 2. Product Categories ─────────────────────────────────────────────────
    setCurrentStep("categories");
    addLog("▶ Step 2 — Product Categories");
    for (let i = 0; i < CATEGORIES.length; i++) {
      if (abortRef.current) break;
      const name = CATEGORIES[i];
      const id = await upsert(
        "/admin/product-categories/", "/admin/product-categories/", "name",
        { name },
        `Category: ${name}`,
        addLog, setErrors
      );
      if (id) catIds[name] = id;
      setProgress((p) => ({ ...p, categories: i + 1 }));
      await sleep(80);
    }

    // ── 3. Chemical / Therapeutic Categories ─────────────────────────────────
    setCurrentStep("chemicalCategories");
    addLog("▶ Step 3 — Chemical / Therapeutic Categories");
    for (let i = 0; i < CHEMICAL_CATEGORIES.length; i++) {
      if (abortRef.current) break;
      const name = CHEMICAL_CATEGORIES[i];
      const id = await upsert(
        "/admin/product-chemical-categories/", "/admin/product-chemical-categories/", "name",
        { name },
        `Chemical: ${name}`,
        addLog, setErrors
      );
      if (id) chemIds[name] = id;
      setProgress((p) => ({ ...p, chemicalCategories: i + 1 }));
      await sleep(80);
    }

    // ── 4. Products ───────────────────────────────────────────────────────────
    setCurrentStep("products");
    addLog("▶ Step 4 — Products");
    const existingProducts = await fetchList("/admin/products/");
    if (existingProducts.error) {
      addLog(`  ⚠ could not preload existing products: ${existingProducts.error}`, "warn");
    } else {
      (existingProducts.results || []).forEach((product) => {
        const key = normalizeName(product.name);
        productIds[key] = product.id;
        existingProductByName[key] = product;
      });
    }

    for (let i = 0; i < PRODUCTS.length; i++) {
      if (abortRef.current) break;
      const p = PRODUCTS[i];
      const content = PRODUCT_CONTENT[p.name] || {};
      const existingProduct = existingProductByName[normalizeName(p.name)] || {};
      const divisionId = divIds[p.division] ?? "";
      const categoryId = catIds[p.category] ?? "";
      const chemicalCategoryId = p.chemical_category ? (chemIds[p.chemical_category] ?? "") : "";

      const payload = {
        name:                      p.name,
        formulation:               p.formulation || "",
        division:                  divisionId,
        product_category:          categoryId,
        product_chemical_category: chemicalCategoryId,
        // ── from docx documents ───────────────────────────────────────────
        composition:               content.composition  || existingProduct.composition  || "",
        description:               content.description  || existingProduct.description  || "",
        packing_size:              content.packing_size || existingProduct.packing_size || "",
        status:                    content.status       || existingProduct.status       || "",
        featured:                  Boolean(existingProduct.featured),
      };

      // Verify division/category IDs resolved correctly
      if (!payload.division) {
        addLog(`  ⚠ "${p.name}": division "${p.division}" not found in ID map — check Step 1`, "warn");
      }
      if (!payload.product_category) {
        addLog(`  ⚠ "${p.name}": category "${p.category}" not found in ID map — check Step 2`, "warn");
      }

      const missingReferences = [];
      if (!divisionId) {
        missingReferences.push(`division "${p.division}"`);
      }
      if (!categoryId) {
        missingReferences.push(`category "${p.category}"`);
      }
      if (p.chemical_category && !chemicalCategoryId) {
        missingReferences.push(`chemical category "${p.chemical_category}"`);
      }

      if (missingReferences.length > 0) {
        const error = `Missing ${missingReferences.join(", ")} — parent record was not created or loaded.`;
        addLog(`  ✗ skipped: [${p.division}] ${p.name} — ${error}`, "error");
        setErrors((prev) => [...prev, `"${p.name}" (${p.division}): ${error}`]);
        setProgress((p2) => ({ ...p2, products: i + 1 }));
        await sleep(60);
        continue;
      }

      const existingProductId = productIds[normalizeName(p.name)];
      const { ok, data, error } = existingProductId
        ? await safePut(`/admin/products/${existingProductId}/`, payload)
        : await safePost("/admin/products/", payload);

      if (ok) {
        productIds[normalizeName(p.name)] = data?.id ?? data?.data?.id ?? existingProductId;
        addLog(`  ✓ [${p.division}] ${p.name}`);
      } else if (isDuplicateError(error)) {
        const productList = await fetchList("/admin/products/");
        const foundProduct = findByName(productList.results, "name", p.name);
        if (foundProduct?.id) {
          const update = await safePut(`/admin/products/${foundProduct.id}/`, payload);
          if (update.ok) {
            productIds[normalizeName(p.name)] = foundProduct.id;
            addLog(`  ✓ updated [${p.division}] ${p.name}`);
          } else {
            addLog(`  ✗ failed update: [${p.division}] ${p.name} — ${update.error}`, "error");
            setErrors((prev) => [...prev, `"${p.name}" (${p.division}): ${update.error}`]);
          }
        } else {
          addLog(`  ~ skip (exists, id unknown): ${p.name}`, "warn");
        }
      } else {
        addLog(`  ✗ failed: [${p.division}] ${p.name} — ${error}`, "error");
        setErrors((prev) => [...prev, `"${p.name}" (${p.division}): ${error}`]);
      }

      setProgress((p2) => ({ ...p2, products: i + 1 }));
      await sleep(60);
    }

    setCurrentStep(null);
    setRunning(false);
    setDone(true);
    addLog("🎉 Import complete!", "success");
  };

  const abort = () => { abortRef.current = true; addLog("⚠ Aborted by user.", "warn"); setRunning(false); setImageRunning(false); };
  const runImageUpload = async (fileList) => {
    const imageFiles = Array.from(fileList || []).filter((file) => IMAGE_FILE_RE.test(file.name));
    if (imageFiles.length === 0) {
      setErrors((prev) => [...prev, "Images: No PNG/JPG/WebP/GIF files selected."]);
      return;
    }

    setImageRunning(true);
    setDone(false);
    setLogs([]);
    setErrors([]);
    setImageProgress({ matched: 0, uploaded: 0, total: imageFiles.length });
    addLog(`▶ Image upload — ${imageFiles.length} file(s) selected`);

    try {
      const productData = await fetchList("/admin/products/");
      const products = productData.results || [];
      if (productData.error || products.length === 0) {
        throw new Error(productData.error || "No products found. Run the product import first.");
      }

      const groups = new Map();
      const unmatched = [];
      const ambiguous = [];

      imageFiles.forEach((file) => {
        const match = matchImageToProduct(file, products);
        if (match.type === "matched") {
          const product = match.product;
          const existingNames = new Set((product.images || []).map((image) => normalizeName(image.file_name || image.name)));
          if (existingNames.has(normalizeName(file.name))) {
            addLog(`  ~ skip image exists: ${file.name}`, "warn");
            return;
          }
          if (!groups.has(product.id)) groups.set(product.id, { product, files: [] });
          groups.get(product.id).files.push(file);
        } else if (match.type === "ambiguous") {
          ambiguous.push(`${file.name} → ${match.matches.join(" / ")}`);
        } else {
          unmatched.push(file.name);
        }
      });

      const matchedCount = [...groups.values()].reduce((sum, group) => sum + group.files.length, 0);
      setImageProgress((current) => ({ ...current, matched: matchedCount }));
      addLog(`  ✓ matched ${matchedCount}/${imageFiles.length} image(s) to products`);

      if (ambiguous.length) {
        addLog(`  ⚠ ${ambiguous.length} ambiguous image(s) skipped`, "warn");
        setErrors((prev) => [...prev, ...ambiguous.slice(0, 30).map((item) => `Ambiguous image: ${item}`)]);
      }
      if (unmatched.length) {
        addLog(`  ⚠ ${unmatched.length} unmatched image(s) skipped`, "warn");
        setErrors((prev) => [...prev, ...unmatched.slice(0, 50).map((name) => `Unmatched image: ${name}`)]);
      }

      let uploaded = 0;
      for (const { product, files } of groups.values()) {
        if (abortRef.current) break;
        const formData = new FormData();
        files.forEach((file) => formData.append("images", file));
        await apiRequest(`/admin/products/${product.id}/images/`, { method: "POST", body: formData });
        uploaded += files.length;
        setImageProgress((current) => ({ ...current, uploaded }));
        addLog(`  ✓ uploaded ${files.length} image(s): ${product.name}`);
        await sleep(80);
      }

      addLog(`🎉 Image upload complete — ${uploaded} uploaded`, "success");
      setDone(true);
    } catch (err) {
      const message = err?.message || String(err);
      addLog(`  ✗ image upload failed — ${message}`, "error");
      setErrors((prev) => [...prev, `Images: ${message}`]);
    } finally {
      setImageRunning(false);
    }
  };

  const reset = () => {
    setDone(false);
    setLogs([]);
    setErrors([]);
    setProgress({ divisions: 0, categories: 0, chemicalCategories: 0, products: 0 });
    setImageProgress({ matched: 0, uploaded: 0, total: 0 });
  };

  const doneItems  = STEPS.reduce((s, k) => s + progress[k], 0);
  const overallPct = Math.round((doneItems / TOTAL_ITEMS) * 100);

  const byDiv = {};
  PRODUCTS.forEach((p) => { if (!byDiv[p.division]) byDiv[p.division] = []; byDiv[p.division].push(p); });
  const contentCount = Object.keys(PRODUCT_CONTENT).length;

  return (
    <div style={{ fontFamily: "'DM Mono',monospace", background: "#0f172a", minHeight: "100vh", color: "#e2e8f0", padding: "32px 24px" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Mono:wght@400;500&family=Space+Grotesk:wght@500;700&display=swap');
        *{box-sizing:border-box}
        ::-webkit-scrollbar{width:6px;height:6px}
        ::-webkit-scrollbar-track{background:#1e293b}
        ::-webkit-scrollbar-thumb{background:#334155;border-radius:3px}
        .hb-step{transition:width .4s ease}
        .hb-pulse{animation:hbpulse 1.4s infinite}
        @keyframes hbpulse{0%,100%{opacity:1}50%{opacity:.35}}
        .hb-fadein{animation:hbfade .3s ease}
        @keyframes hbfade{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:translateY(0)}}
      `}</style>

      <div style={{ maxWidth: 900, margin: "0 auto" }}>

        {/* Header */}
        <div style={{ marginBottom: 28 }}>
          <div style={{ fontSize: 11, letterSpacing: 3, color: "#64748b", marginBottom: 8, textTransform: "uppercase" }}>Quick Shift Importer — Fixed</div>
          <h1 style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 26, fontWeight: 700, margin: 0, color: "#f1f5f9" }}>Bulk Product Import</h1>
          <p style={{ marginTop: 8, fontSize: 13, color: "#64748b", lineHeight: 1.7 }}>
            Imports{" "}
            <b style={{ color: "#94a3b8" }}>{DIVISIONS.length} divisions</b>,{" "}
            <b style={{ color: "#94a3b8" }}>{CATEGORIES.length} product categories</b>,{" "}
            <b style={{ color: "#94a3b8" }}>{CHEMICAL_CATEGORIES.length} chemical / therapeutic categories</b> and{" "}
            <b style={{ color: "#94a3b8" }}>{PRODUCTS.length} products</b>{" "}
            (<b style={{ color: "#a78bfa" }}>{contentCount} with full composition & description</b>) via{" "}
            <span style={{ color: "#2eb4b4" }}>api.dreamcapture.in</span>.
          </p>
        </div>

        {/* Preview cards */}
        {!running && !done && (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(190px,1fr))", gap: 12, marginBottom: 28 }}>
            {Object.entries(byDiv).map(([div, prods]) => (
              <div key={div} style={{ background: "#1e293b", border: `1px solid ${DIV_COLOR[div] || "#334155"}33`, borderLeft: `3px solid ${DIV_COLOR[div] || "#64748b"}`, borderRadius: 8, padding: "14px 16px" }}>
                <div style={{ fontSize: 11, fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, color: DIV_COLOR[div] || "#64748b", marginBottom: 4 }}>{div}</div>
                <div style={{ fontSize: 22, fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, color: "#f1f5f9" }}>{prods.length}</div>
                <div style={{ fontSize: 11, color: "#64748b" }}>products</div>
              </div>
            ))}
            <div style={{ background: "#1e293b", border: "1px solid #334155", borderLeft: "3px solid #a78bfa", borderRadius: 8, padding: "14px 16px" }}>
              <div style={{ fontSize: 11, fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, color: "#a78bfa", marginBottom: 4 }}>With Content</div>
              <div style={{ fontSize: 22, fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, color: "#f1f5f9" }}>{contentCount}</div>
              <div style={{ fontSize: 11, color: "#64748b" }}>have composition + desc</div>
            </div>
          </div>
        )}

        {/* Chemical categories chips */}
        {!running && !done && (
          <div style={{ background: "#1e293b", border: "1px solid #334155", borderRadius: 10, padding: "16px 20px", marginBottom: 24 }}>
            <div style={{ fontSize: 11, letterSpacing: 2, color: "#a78bfa", marginBottom: 12, textTransform: "uppercase", fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700 }}>
              Therapeutic / Chemical Categories
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {CHEMICAL_CATEGORIES.map((c) => (
                <span key={c} style={{ fontSize: 12, background: "#0f172a", border: "1px solid #334155", borderRadius: 6, padding: "4px 12px", color: "#cbd5e1" }}>{c}</span>
              ))}
            </div>
          </div>
        )}

        {/* Progress bars */}
        {(running || done) && (
          <div style={{ background: "#1e293b", border: "1px solid #334155", borderRadius: 12, padding: 24, marginBottom: 24 }} className="hb-fadein">
            <div style={{ marginBottom: 20 }}>
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: "#94a3b8", marginBottom: 8 }}>
                <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700 }}>Overall Progress</span>
                <span>{doneItems} / {TOTAL_ITEMS} ({overallPct}%)</span>
              </div>
              <div style={{ background: "#0f172a", borderRadius: 6, height: 8, overflow: "hidden" }}>
                <div className="hb-step" style={{ height: "100%", width: `${overallPct}%`, background: "linear-gradient(90deg,#2eb4b4,#174f9a)", borderRadius: 6 }} />
              </div>
            </div>
            {STEPS.map((step) => {
              const pct   = Math.round((progress[step] / STEP_COUNTS[step]) * 100);
              const isCur = currentStep === step;
              const isDone = progress[step] === STEP_COUNTS[step];
              return (
                <div key={step} style={{ marginBottom: 14 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, marginBottom: 5 }}>
                    <span style={{ color: isCur ? "#2eb4b4" : isDone ? "#10b981" : "#64748b", display: "flex", alignItems: "center", gap: 6 }}>
                      {isCur  && <span className="hb-pulse">●</span>}
                      {isDone && !isCur && <span style={{ color: "#10b981" }}>✓</span>}
                      {!isCur && !isDone && <span>○</span>}
                      {STEP_LABELS[step]}
                    </span>
                    <span style={{ color: "#475569" }}>{progress[step]}/{STEP_COUNTS[step]}</span>
                  </div>
                  <div style={{ background: "#0f172a", borderRadius: 4, height: 5, overflow: "hidden" }}>
                    <div className="hb-step" style={{ height: "100%", width: `${pct}%`, background: isDone ? "#10b981" : isCur ? "#2eb4b4" : "#334155", borderRadius: 4 }} />
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Log terminal */}
        {logs.length > 0 && (
          <div style={{ background: "#020617", border: "1px solid #1e293b", borderRadius: 10, marginBottom: 24 }}>
            <div style={{ padding: "10px 16px", borderBottom: "1px solid #1e293b", display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#ef4444" }} />
              <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#f59e0b" }} />
              <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#10b981" }} />
              <span style={{ marginLeft: 8, fontSize: 11, color: "#475569" }}>import.log</span>
              {running && <span className="hb-pulse" style={{ marginLeft: "auto", fontSize: 11, color: "#2eb4b4" }}>● RUNNING</span>}
              {done    && <span style={{ marginLeft: "auto", fontSize: 11, color: "#10b981" }}>● DONE</span>}
            </div>
            <div ref={logsRef} style={{ maxHeight: 360, overflowY: "auto", padding: "12px 16px", fontSize: 12, lineHeight: 1.8 }}>
              {logs.map((e, i) => (
                <div key={i} style={{ color: e.type === "error" ? "#f87171" : e.type === "warn" ? "#fbbf24" : e.type === "success" ? "#34d399" : "#94a3b8" }}>
                  {e.msg}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Error summary */}
        {errors.length > 0 && !running && (
          <div style={{ background: "#450a0a", border: "1px solid #7f1d1d", borderRadius: 10, padding: "16px 20px", marginBottom: 24 }} className="hb-fadein">
            <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, color: "#f87171", marginBottom: 10, fontSize: 14 }}>
              {errors.length} error{errors.length > 1 ? "s" : ""} occurred
            </div>
            {errors.map((e, i) => <div key={i} style={{ fontSize: 12, color: "#fca5a5", marginBottom: 4 }}>• {e}</div>)}
          </div>
        )}

        {/* Success banner */}
        {done && errors.length === 0 && (
          <div style={{ background: "#052e16", border: "1px solid #14532d", borderRadius: 10, padding: "20px", marginBottom: 24, textAlign: "center" }} className="hb-fadein">
            <div style={{ fontSize: 28, marginBottom: 6 }}>🎉</div>
            <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, color: "#34d399", fontSize: 16 }}>
              {imageProgress.total > 0
                ? `${imageProgress.uploaded} product image${imageProgress.uploaded === 1 ? "" : "s"} uploaded successfully!`
                : `All ${TOTAL_ITEMS} items imported successfully!`}
            </div>
          </div>
        )}

        {/* Buttons */}
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          <input
            ref={imageInputRef}
            type="file"
            accept="image/*"
            multiple
            webkitdirectory=""
            directory=""
            style={{ display: "none" }}
            onChange={(event) => {
              runImageUpload(event.target.files);
              event.target.value = "";
            }}
          />
          {!running && !imageRunning && (
            <button onClick={run} style={{ background: "linear-gradient(135deg,#2eb4b4,#174f9a)", border: "none", borderRadius: 8, padding: "13px 28px", color: "#fff", fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
              {done ? "↺ Re-Run Import" : "▶ Start Import"}
            </button>
          )}
          {!running && !imageRunning && (
            <button onClick={() => imageInputRef.current?.click()} style={{ background: "#1e293b", border: "1px solid #2eb4b4", borderRadius: 8, padding: "13px 24px", color: "#a7f3d0", fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
              Upload Product Images
            </button>
          )}
          {(running || imageRunning) && (
            <button onClick={abort} style={{ background: "#7f1d1d", border: "none", borderRadius: 8, padding: "13px 28px", color: "#fca5a5", fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
              ■ Abort
            </button>
          )}
          {done && !running && !imageRunning && (
            <button onClick={reset} style={{ background: "#1e293b", border: "1px solid #334155", borderRadius: 8, padding: "13px 24px", color: "#94a3b8", fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
              Reset
            </button>
          )}
        </div>

        {imageProgress.total > 0 && (
          <div style={{ marginTop: 12, fontSize: 12, color: "#94a3b8" }}>
            Images: matched {imageProgress.matched}/{imageProgress.total}, uploaded {imageProgress.uploaded}/{imageProgress.matched}
          </div>
        )}

        <p style={{ marginTop: 16, fontSize: 11, color: "#475569", lineHeight: 2 }}>
          • <b style={{ color: "#f87171" }}>Fixes applied</b>: robust duplicate detection (checks "unique", "constraint", "violat", "integrity", "duplicate" + original patterns) · error extraction handles all error shapes · division/category ID warnings if lookup fails.<br />
          • Each product now includes <b style={{ color: "#a78bfa" }}>composition</b>, <b style={{ color: "#a78bfa" }}>description</b>, <b style={{ color: "#a78bfa" }}>packing_size</b> and <b style={{ color: "#a78bfa" }}>status</b> from the uploaded documents.<br />
          • Uses <code style={{ color: "#2eb4b4" }}>apiRequest</code> — auth token sent automatically.<br />
          • Endpoints: <code style={{ color: "#2eb4b4" }}>/admin/divisions/</code> · <code style={{ color: "#2eb4b4" }}>/admin/product-categories/</code> · <code style={{ color: "#2eb4b4" }}>/admin/product-chemical-categories/</code> · <code style={{ color: "#2eb4b4" }}>/admin/products/</code>
        </p>
      </div>
    </div>
  );
}
